import $api from "@/zapi-frontend/shared/api/axios";
import { TUser, TUserRole } from "./schemas";

export async function updateUser({
  orgId,
  userId,
  role,
  active
}: {
  orgId: number;
  userId: number;
  role: TUserRole;
  active: boolean;
}) {
  const response = await $api.patch<TUser>(`/organizations/${orgId}/users/${userId}`, {
    role,
    active
  });
  //   const parsed = UserSchema.parse(response.data);
  //   return parsed;
  return response.data;
}
